"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.routes = void 0;
const types_1 = require("./types");
exports.routes = (0, types_1.buildRoutes)({
    logs: {
        path: "/logs",
    },
    createLog: {
        path: "/logs/create/:propertyId",
    },
    editLog: {
        path: "/logs/:id",
    },
});
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoibG9ncy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3JvdXRpbmcvbG9ncy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSxtQ0FBc0M7QUFFekIsUUFBQSxNQUFNLEdBQUcsSUFBQSxtQkFBVyxFQUFDO0lBQ2hDLElBQUksRUFBRTtRQUNKLElBQUksRUFBRSxPQUFPO0tBQ2Q7SUFDRCxTQUFTLEVBQUU7UUFDVCxJQUFJLEVBQUUsMEJBQTBCO0tBQ2pDO0lBQ0QsT0FBTyxFQUFFO1FBQ1AsSUFBSSxFQUFFLFdBQVc7S0FDbEI7Q0FDRixDQUFDLENBQUMiLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBidWlsZFJvdXRlcyB9IGZyb20gXCIuL3R5cGVzXCI7XG5cbmV4cG9ydCBjb25zdCByb3V0ZXMgPSBidWlsZFJvdXRlcyh7XG4gIGxvZ3M6IHtcbiAgICBwYXRoOiBcIi9sb2dzXCIsXG4gIH0sXG4gIGNyZWF0ZUxvZzoge1xuICAgIHBhdGg6IFwiL2xvZ3MvY3JlYXRlLzpwcm9wZXJ0eUlkXCIsXG4gIH0sXG4gIGVkaXRMb2c6IHtcbiAgICBwYXRoOiBcIi9sb2dzLzppZFwiLFxuICB9LFxufSk7XG4iXX0=